import React, { useState } from "react";
import { Button } from "@mui/material";
import { AddRounded } from "@mui/icons-material";
import { Layout } from "Components/Layout/Layout";
import FaultRuleForm from "Components/FaultRules/FaultRuleForm/FaultRuleForm";
import FaultRuleDashboard from "Containers/FaultRules/FaultRulesList/FaultRuleDashboard/FaultRuleDashboard";
import { useSettingsAccess } from "Containers/Settings/SettingsHub/useSettingsAccess";
import { MODULES, PERMISSIONS } from "Shared/Types/permissions";

export const FaultRulesPage = () => {
  const { permissions, loading } = useSettingsAccess();
  const [creating, setCreating] = useState(false);
  const can = (permission: PERMISSIONS) => !!permissions && (permissions.has_full_access || (
    permissions.modules.has(MODULES.FAULTS_RULES) && (
      permissions.available_permissions.has(PERMISSIONS.FULL_FAULTS_RULES_ACCESS) ||
      permissions.available_permissions.has(permission)
    )
  ));
  const canView = can(PERMISSIONS.VIEW_FAULTS_RULES);
  const canCreate = can(PERMISSIONS.CREATE_FAULTS_RULES);

  return <Layout>
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, marginBottom: 20 }}>
      <h1>Fault rules</h1>
      {!loading && canView && canCreate && <Button variant="outlined" startIcon={<AddRounded />} onClick={() => setCreating(true)}>Add fault rule</Button>}
    </div>
    {loading ? <p role="status">Loading fault-rule access…</p> : canView ? <FaultRuleDashboard /> : <p role="alert">Your role does not have access to fault rules.</p>}
    {creating && canView && canCreate && <FaultRuleForm type="CREATE" open onClose={() => setCreating(false)} />}
  </Layout>;
};
